export const uid = () =>
  "_" +
  Math.random()
    .toString(36)
    .substr(2, 9)

export const emailIsValid = email => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}
